<template>
	<router-link :to="{ name: pathname }">{{ linkText }}</router-link>
</template>

<script>
export default {
	name: 'RouterLinkComponent',
	props: {
		pathname: String,
		linkText: String
	}
}
</script>

<style scoped lang="stylus">
.router-link-exact-active,  a:hover {
    color: red;
}

a {
    color: #fff;
	margin-bottom: 5px;
}
</style>
